// Mock data for Hercules Comunicação Visual
export const hero = {
  title: "HÉRCULES",
  subtitle: "Comunicação Visual de alto impacto",
  description:
    "Fabricamos posts para outdoors, letras gigantes (neon/LED), fachadas e soluções completas de comunicação visual.",
  whatsapp: "https://wa.me/0000000000", // TODO: substituir pelo número real
  instagram: "https://instagram.com/hercules_placeholder", // TODO: substituir pelo @ real
};

export const services = [
  {
    id: "outdoor",
    title: "Posts para Outdoors",
    description:
      "Impressão em alta definição no papel especial para outdoors (front/back), com resistência e cores vivas.",
    highlights: ["Papel especial", "Cores fiéis", "Entrega rápida"],
  },
  {
    id: "letras",
    title: "Letras Gigantes",
    description:
      "Letras 3D para fachadas e interiores, com opções em neon e LED para máximo destaque.",
    highlights: ["Neon/LED", "Acabamento premium", "Corte a laser"],
  },
  {
    id: "fachadas",
    title: "Fachadas e Painéis",
    description:
      "Projeto, produção e instalação de fachadas, totens e painéis para elevar sua presença de marca.",
    highlights: ["Projeto completo", "Instalação", "Garantia"],
  },
  {
    id: "banners",
    title: "Banners e Sinalização",
    description:
      "Banners, placas e sinalização interna/externa com materiais duráveis e acabamento perfeito.",
    highlights: ["Lona/PVC", "UV Print", "Durabilidade"],
  },
  {
    id: "veiculos",
    title: "Envelopamento de Veículos",
    description:
      "Plotagem e envelopamento parcial ou total com vinil automotivo de alta performance.",
    highlights: ["Vinil premium", "Aplicação técnica", "Proteção UV"],
  },
];

export const faqs = [
  {
    q: "Qual o prazo médio de produção?",
    a: "Depende do volume e do serviço. Peças simples (banners) podem sair em 24-48h; projetos com letras 3D e neon variam de 5 a 12 dias úteis.",
  },
  {
    q: "Vocês fazem instalação?",
    a: "Sim. Oferecemos instalação técnica para fachadas, painéis e letras, com equipe própria e garantia.",
  },
  {
    q: "Trabalham com projetos sob medida?",
    a: "Totalmente. Criamos do zero ou adaptamos seu layout. Nosso time orienta em materiais e viabilidade.",
  },
  {
    q: "Emitimos nota fiscal?",
    a: "Sim, para todos os serviços e produtos.",
  },
];

export const stats = [
  { label: "Projetos Entregues", value: "+1.500" },
  { label: "Anos de Mercado", value: "12" },
  { label: "Clientes Ativos", value: "+300" },
];
